import { imagePreviewActionTypes } from '@/components/modals/imagePreview/Constants';

import type { ImagePreviewActions, ImagePreviewState, SetImagePreviewAction } from './types';

const initialState: ImagePreviewState = {
	open: false,
	imageSrc: null,
};

export default function imagePreviewModalReducer(
	state = initialState,
	action: ImagePreviewActions,
): ImagePreviewState {
	switch (action.type) {
		case imagePreviewActionTypes.SET_IMAGE_PREVIEW: {
			const { data } = (action as SetImagePreviewAction).payload;
			return { ...state, ...data };
		}
		default:
			return state;
	}
}
